jQuery(document).ready(function($){
	function product_grid_sizer() {
		setTimeout(function() {
		$('.product_grid_wrapper').each(function(num, elem) {
			let $column_top_height = 114;
			let $column_tops = $(this).find('.product_row_top');
			let $product_columns = $(this).find('.product_column');
			let $labels_column = $(this).find('.labels_column');
			let $background = $(this).find('.background');
			let $innerTrack = $(this).find('.inner_track');
			var $row_heights = [];
			let $columnsWidth = 0;
			$product_columns.each(function(num, elem) {
				$columnsWidth += $(elem).outerWidth();
			});
			if ($innerTrack.innerWidth() < $columnsWidth) {
				$product_columns.each(function(num, elem) {
					$(elem).find('.pin').removeClass('hide');
				});
			} else if ($innerTrack.innerWidth() > $columnsWidth) {
				$product_columns.each(function(num, elem) {
					$(elem).find('.pin').addClass('hide');
				});
			}
			$column_tops.each(function(num, elem) {			
				$(this).removeAttr("style");
				if ($(this).outerHeight() > $column_top_height) {
					$column_top_height = $(this).outerHeight();
				}
			});
			$column_tops.css('height',$column_top_height);
			$(this).find('.top_spacer').css('height',$column_top_height);
			$product_columns.each(function(num, elem) {
				let $rows = $(this).find('.product_row');
				$rows.each(function(num, elem) {
					$(this).removeAttr("style");
					if ($row_heights[num]) {
						if ($(this).outerHeight() > $row_heights[num]) {
							$row_heights[num] = $(this).outerHeight();
						}
					} else {
						$row_heights[num] = $(this).outerHeight();
					}
				});
			});
			$labels_column.each(function(num, elem) {
				let $rows = $(this).find('.row_label');
				$rows.each(function(num, elem) {
					$(this).removeAttr("style");
					if ($row_heights[num]) {
						if ($(this).outerHeight() > $row_heights[num]) {
							$row_heights[num] = $(this).outerHeight();
						}
					} else {
						$row_heights[num] = $(this).outerHeight();
					}
				});
			});
			$labels_column.each(function(num, elem) {
				let $rows = $(this).find('.row_label');
				$rows.each(function(num, elem) {
					$(this).css('height',$row_heights[num]);
				});
			});
			$product_columns.each(function(num, elem) {
				let $rows = $(this).find('.product_row');
				$rows.each(function(num, elem) {
					$(this).css('height',$row_heights[num]);
				});
			});
			let $sum = 0;
			$.each($row_heights,function(){$sum+=parseFloat(this) || 0;});
			$background.css('top',$column_top_height);
			$background.css('height',$sum);
		})}, 100);
	}
	product_grid_sizer();
	$(window).on('resize', function() {
		product_grid_sizer();
	});

	// Pin a product column
	$(document).on( 'click', '.pin', function() {
		let $pin = $(this);
		let $column = $(this).closest('.product_column');
		let $track = $(this).closest('.inner_track');
		let $allColumns = $column.siblings();
		var $currentPin = false;
		$track.removeAttr("style");
		$allColumns.each(function(num, elem){
			if($(elem).hasClass('pinned')) {
				$currentPin = true;
				$(elem).removeClass('pinned');
				$(elem).find('.pin').html('Pin');
			}
		});
		let $paddingRight = $track.innerWidth()-($column.outerWidth()*2);
		$track.css('paddingRight',$paddingRight);
		if ($currentPin) {
			$column.addClass('pinned');
			$pin.html('Pinned');
		} else if ($column.hasClass('pinned')) {
			$column.removeClass('pinned');
			$track.removeClass('has_pin');
			$pin.html('Pin');
			$track.removeAttr("style");
		} else {
			$column.addClass('pinned');
			$track.addClass('has_pin');
			$pin.html('Pinned');
		}
	});
});